<template>
  <div class="container" style="padding-bottom: 20px;">
    <div class="common-header-wrap">
      <mt-header :title="getTitle" class="common-header">
        <mt-button slot="left" icon="back" @click="goBack"></mt-button>
      </mt-header>
    </div>

    <DragAddressMarkerOnMap
      v-show="true"
      mapHeight="200px"
      :center="addressLocation"
      :address-detail="address_info.address_detail"
      @update:position="updatePosition"
    >
    </DragAddressMarkerOnMap>

    <div class="form">
      <!-- 地址 -->
      <div class="mint-cell mint-field">
        <div class="mint-cell-wrapper">
          <div class="mint-cell-title">
            <span class="mint-cell-text">{{ getAddressLabelText }}</span>
          </div>
          <div class="mint-cell-value">
            <GmapAutocomplete
              class="mint-field-core"
              :options="this.autocompleteOptions"
              :value="$v.address_info.address_detail.$model"
              @blur="setDefaultAddress"
              @place_changed="setPlace">
            </GmapAutocomplete>
          </div>
          <div class="mint-field-other">
            <div class="input-wrap">
              <i class="iconfont" @click="relocate">&#xe6d3;</i>
            </div>
          </div>
        </div>
      </div>
      <!-- 樓層與房號 -->
      <custom-mt-field
          :disableClear="true"
          :hiddenState="true"
          v-model.trim="$v.address_info.address_floor.$model"
          :label="$t('address.floor')"
          :placeholder="$t('address.floor')"
          :validationParam="$v.address_info.address_floor"
          class="menu-item"
      >
      </custom-mt-field>
      <!-- 姓名 -->
      <custom-mt-field
          :hiddenState="true"
          v-model.trim="$v.address_info.address_realname.$model"
          :label="getNameLabelText"
          :placeholder="getNameLabelText"
          :validationParam="$v.address_info.address_realname"
          class="menu-item"
      ></custom-mt-field>
      <!-- 手機號碼 -->
      <custom-mt-field
          :hiddenState="true"
          v-model.trim="$v.address_info.address_mob_phone.$model"
          :label="$t('address.address_mob_phone')"
          :placeholder="$t('address.address_mob_phone')"
          :validationParam="$v.address_info.address_mob_phone"
          class="menu-item"
      ></custom-mt-field>
      <!-- 預設地址 -->
      <custom-mt-field
          :isReadOnly="true"
          :disableClear="true"
          :hiddenState="true"
          :label="$t('address.default_address')"
          class="menu-item"
      >
        <mt-switch v-model.number="$v.address_info.address_is_default.$model"></mt-switch>
      </custom-mt-field>
      <!-- 標籤 -->
      <custom-mt-field
          :hiddenState="true"
          v-model.trim="$v.address_info.label.$model"
          :label="$t('address.label')"
          :placeholder="$t('placeholder.address.label')"
          :validationParam="$v.address_info.label"
          class="menu-item"
      ></custom-mt-field>
      <!-- 備註 -->
      <custom-mt-field
          :hiddenState="true"
          v-model.trim="$v.address_info.note.$model"
          :label="$t('address.note')"
          :placeholder="$t('address.note')"
          :validationParam="$v.address_info.note"
          class="menu-item"
          type="textarea"
          rows="3"
      ></custom-mt-field>
    </div>

    <mt-button class="ds-button-large mt-10" size="large" type="primary" :disabled="$v.$invalid" v-on:click="submit">{{ $t('general.save') }}
    </mt-button>
    <region-picker ref="picker" v-on:onConfirm="onPickerConfirm"></region-picker>

    <!-- 定位 or 輸入地址 -->
    <mt-popup v-model="popMap" class="common-popup-wrapper" position='right'>
      <div class="common-header-wrap">
        <mt-header class="common-header" title="定位">
          <mt-button slot="left" icon="back" @click="popMap=false"></mt-button>
        </mt-header>
      </div>
      <div class="common-popup-content" style="top: 4rem">
        <map-select ref="map_select" :latitude="address_info.address_latitude" :region="address_info.address_detail"
                    :longitude="address_info.address_longitude" @setPosition="setPosition"></map-select>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import { Indicator, Toast } from 'mint-ui'
import RegionPicker from '../../../components/RegionPicker'
import MapSelect from '../../../components/MapSelect'
import { AddressState } from '@src/const/address'
import { addAddress, editAddress, getAddressInfo } from '../../../api/memberAddress'
import CustomMtField from '../../basic/CustomMtField'
import { minLength, maxLength, required, requiredIf } from 'vuelidate/lib/validators'
import validator from '@src/util/validator'
import DragAddressMarkerOnMap from '../../DragAddressMarkerOnMap'
import { geocode, transformAddress } from '@src/util/map'
import { mapState, mapMutations } from 'vuex'
import { showLoading } from '@src/util/common'
import { getPosition } from '@src/util/map'

export default {
  components: {
    RegionPicker,
    MapSelect,
    CustomMtField,
    DragAddressMarkerOnMap
  },
  validations: {
    address_id: {
      requiredIf: requiredIf(function () {
        return !this.isAddMode
      })
    },
    address_info: {
      label: {
        maxLength: maxLength(15)
      },
      note: {
        maxLength: maxLength(50)
      },
      address_o2o_errand_type: {
        required,
        errandType: function (val) {
          return [0, 1].indexOf(val) > -1
        }
      },
      address_is_default: {
        required
      },
      address_realname: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(50)
      },
      address_mob_phone: {
        required,
        mobile: validator.mobile
      },
      address_detail: {
        required,
        maxLength: maxLength(100)
      },
      address_floor: {
        maxLength: maxLength(25)
      },
      address_longitude: {
        required,
        isFloat: validator.isFloat
      },
      address_latitude: {
        required,
        isFloat: validator.isFloat
      },
      address_postal_code: {}
    }
  },
  computed: {
    ...mapState({
      member: state => state.member.info,
      member_point: state => state.member.point
    }),
    fromMemberProfile () {
      return this.$route.query.from === 'member_profile'
    },
    isPickUpPoint () {
      return Number(this.$route.query.o2o_errand_type) === AddressState.PICKUP_POINT
    },
    isDeliveryPoint () {
      return Number(this.$route.query.o2o_errand_type) === AddressState.DELIVERY_POINT
    },
    isAddMode () {
      return this.$route.query.action === AddressState.ACTION_ADD
    },
    getTitle () {
      if (this.isAddMode) {
        return this.isDeliveryPoint || this.isPickUpPoint && this.fromMemberProfile ? this.$t('address.add_receiver_address') : this.$t('address.add_sender_address')
      } else {
        return this.isDeliveryPoint || this.isPickUpPoint && this.fromMemberProfile ? this.$t('address.modify_receiver_address') : this.$t('address.modify_sender_address')
      }
    },
    getAddressLabelText () {
      return this.isDeliveryPoint || this.isPickUpPoint && this.fromMemberProfile ? this.$t('address.receiver_address') : this.$t('address.sender_address')
    },
    getNameLabelText () {
      return this.isDeliveryPoint || this.isPickUpPoint && this.fromMemberProfile ? this.$t('address.address_receiver_name') : this.$t('address.address_sender_name')
    },
    addressLocation () {
      return {
        lat: this.address_info.address_latitude,
        lng: this.address_info.address_longitude
      }
    }
  },
  data () {
    return {
      popMap: false,
      geocoderOptions: {
        region: 'Taiwan'
      },
      address_id: 0,
      address_info: {
        label: '',
        note: '',
        address_o2o_errand_type: this.$route.query.o2o_errand_type ? this.$route.query.o2o_errand_type : 0,
        address_detail: '',
        address_floor: '',
        address_mob_phone: '',
        address_realname: '',
        house_number: '',
        address_is_default: true,
        address_postal_code: undefined,
        address_longitude: 0,
        address_latitude: 0
      },
      addressNeedRequest: false,
      autocompleteOptions: {
        componentRestrictions: {
          country: 'tw'
        },
        fields: [
          'geometry',
          'formatted_address',
          'address_components',
          'plus_code'
        ]
      },
    }
  },
  watch: {
    '$v.address_info.address_detail.$model': {
      handler: async function (val, oldval) {
        if (val === '') {
          return
        }

        try {          
          await this.getAddressLatitudeAndLongitude(val)
        } catch (err) {
          console.error(err)
        }
      }
    },
  },
  created: async function () {
    this.$v.address_id.$model = this.$route.query.address_id
    this.$v.address_info.address_o2o_errand_type.$model = Number(this.$route.query.o2o_errand_type || 0)

    if (this.isAddMode) {
      this.$v.address_info.address_latitude.$model = this.member.latitude 
      this.$v.address_info.address_longitude.$model =this.member.longitude
      if (this.isDeliveryPoint) {
        this.$v.address_info.address_realname.$model = this.member.member_truename
        this.$v.address_info.address_mob_phone.$model = this.member.member_mobile
      }
    } else {
      try {
        const res = await getAddressInfo(this.$v.address_id.$model)
        const addressInfo = res.result.address_info
        addressInfo.address_latitude = Number(addressInfo.address_latitude)
        addressInfo.address_longitude = Number(addressInfo.address_longitude)
        addressInfo.address_is_default = addressInfo.address_is_default === '1'
        this.$v.address_info.$model = addressInfo
      } catch (err) {
        Toast(err.message)
      }
    }
  },
  methods: {
    ...mapMutations({
      memberPoint: 'memberPoint'      
    }),
    showLoading,
    geocode,
    transformAddress,
    async getAddressLatitudeAndLongitude(val) {
      const options = this.geocoderOptions
      options.address = val
      const result = await this.geocode(options)
      const location = result.geometry.location
      const postal_code_component = result.address_components.filter(component => component.types.indexOf('postal_code') > -1).shift()
      const postal_code = postal_code_component ? postal_code_component.long_name : undefined
      this.$v.address_info.address_latitude.$model = Number(location.lat())
      this.$v.address_info.address_longitude.$model = Number(location.lng())
      this.address_info.address_postal_code = postal_code
      this.$v.address_info.address_postal_code.$model = postal_code
    },
    async getAddress(lat, lng) {      
      const options = this.geocoderOptions      
      options.location = { lat: lat, lng: lng }
      const result = await this.geocode(options)
      const addressDetail = this.transformAddress(result.address_components)
      this.$v.address_info.address_detail.$model = addressDetail
    },
    handleDragAddressMarkerOnMapFullScreen () {
      this.$refs.DragAddressMarkerOnMap.requestFullscreen()
    },
    async updatePosition (position) {
      try {
        const result = await this.geocode({
          location: new this.$google.maps.LatLng(position.lat, position.lng)
        })
        this.address_info.address_detail = this.transformAddress(result['address_components'])
      } catch (err) {
        console.error(err)
      }
      this.address_info.address_latitude = position.lat
      this.address_info.address_longitude = position.lng
    },
    goBack () {
      this.$router.go(-1)
    },
    setPosition (lat, lng, name) {
      this.popMap = false
      this.address_info.address_detail = name
      this.address_info.address_longitude = lng
      this.address_info.address_latitude = lat
    },
    async submit () {      
      if (this.addressNeedRequest) {        
        await this.getAddressLatitudeAndLongitude(this.address_info.address_detail)          
      }
      
      this.address_info.address_is_default = this.address_info.address_is_default ? '1' : '0'
      if (this.isAddMode) {
        Indicator.open()
        addAddress(this.address_info).then(
          (response) => {
            Indicator.close()
            if (this.$route.query.set_member_point) {
              this.memberPoint({ point: {
                lat: this.address_info.address_latitude,
                lng: this.address_info.address_longitude,
                address: this.address_info.address_detail
              } })
            }
            this.updateSelectedAddress()
          }, (error) => {
            Indicator.close()
            Toast(error.message)
          })
      } else {
        Indicator.open()
        editAddress(this.address_info, this.address_id).then(
          (response) => {
            Indicator.close()
            this.updateSelectedAddress()
          }, (error) => {
            Indicator.close()
            Toast(error.message)
          })
      }
      
      if (this.address_info.address_is_default === '1' && this.isPickUpPoint) {
          this.memberPoint({ point: {
            lat: this.address_info.address_latitude,
            lng: this.address_info.address_longitude,
            address: this.address_info.address_detail
          } })
      }
    },
    onRegion (picker, values) {
      this.$refs.picker.currentValue = true
    },
    onPickerConfirm (values) {
      this.address_info.area_info = this.getRegionStr(values)

      this.address_info.address_detail = ''

      this.address_info.area_id = values[2].area_id
      this.address_info.city_id = values[1].area_id
    },
    getRegionStr (values) {
      let title = ''
      for (let i = 0; i < values.length; i++) {
        const element = values[i]
        if (i !== 0) {
          title = title + ' ' + element.area_name
        } else {
          title = title + element.area_name
        }
      }
      return title
    },
    updateSelectedAddress () {
      let isFromCheckout = this.$route.query.isFromCheckout
      let goBackLevel = this.$route.query.goBackLevel ? this.$route.query.goBackLevel : -1
      if (isFromCheckout) {
        this.$router.go(goBackLevel)
      } else {
        this.goBack()
      }
    },    
    setPlace(place) {      
      this.addressNeedRequest = !navigator.onLine
      this.$v.address_info.address_detail.$model = this.transformAddress(place.address_components)
    },
    setDefaultAddress() {      
      document.querySelector('.pac-target-input').value = this.address_info.address_detail
    },
    relocate () {
      /**
       * @todo Webview 請求定位權限
       */
      Indicator.open(this.$i18n.t('map.relocating'))

      getPosition((res) => {
        this.address_info.address_latitude = res.coords.latitude
        this.address_info.address_longitude = res.coords.longitude
        Indicator.close()
      }, (err) => {
        console.error(err)
        Indicator.close()
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.right-arrow {
  transform: rotate(-90deg);
  color: #ddd;
  font-size: .6rem;
  display: inline-block;
}

.input-wrap {
  position: relative;

  i {
    font-size: 1.3rem;
    font-weight: 1000;
    color: $primaryColor
  }
}

.map-content {
  width:  100% !important;
  height: 200px !important;
  margin-bottom: -20px;
}

</style>
